
import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome'
import { Tabs, Tab, Breadcrumb } from 'react-bootstrap'
import {connect} from 'react-redux'
import {Switch,Route,withRouter} from 'react-router-dom'
import ReportAssetVehiclePage from '../tyre/report-asset-vehicle-page/ReportAssetVehiclePage'
import ReportAssetPage from './ReportAssetPage'
class ReportAllAssetPage extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      is_tab:true,
      activeKey:'vehicle',
      showTbReportAssetVehiclePage:false,
      showTbReportAssetPage:false,
      item:{}
    }
  }

  componentDidMount() {
    this.setTab()
  }

  setTab() {
    let {location} = this.props
    if (location.pathname==='/asset')
      this.onTabsSelect('asset')
    else
      this.onTabsSelect('vehicle')
  }

  getItemDetail() {
    let {activeKey,item} = this.state
    let detail = ''
    if (activeKey==='vehicle')
      detail = typeof item.vehicle_registration_no!=='undefined'?item.vehicle_registration_no:''
    else
      detail = typeof item.asset_code!=='undefined'?item.asset_code:''
    return detail  
  }

  onTabsSelect(key) {
    // let {location} = this.props
    let pathname = '/'+key
    // if (key==='report-asset-vehicle') {
    //   let param = location.pathname.replace('/'+key, '')
    //   pathname += param
    // }
    this.setState({activeKey:key,showTbReportAssetVehiclePage:false,showTbReportAssetPage:false})
    this.props.history.push({pathname:pathname,search:'',state:{}})
  }

  onShowTabs(status) {
    this.setState({is_tab:status,showTbReportAssetVehiclePage:false,showTbReportAssetPage:false})
  }

  onBreadcrumbClick(key) {
    this.setState({is_tab:true,activeKey:key})
    this.props.history.push({pathname:'/'+key,search:'',state:{}})
    if (key==='vehicle')
      this.setState({showTbReportAssetVehiclePage:true,showTbReportAssetPage:false})
    else if (key==='asset')  
      this.setState({showTbReportAssetVehiclePage:false,showTbReportAssetPage:true})
  }

  onRowSelect(item) {
    this.setState({item:item})
  }

  renderReportAssetVehicleTab() {
    return(
      <ReportAssetVehiclePage
        ref='report_asset_vehicle'
        onShowTabs={this.onShowTabs.bind(this)}
        onRowSelect={this.onRowSelect.bind(this)}
        showTbReportAssetVehiclePage={this.state.showTbReportAssetVehiclePage}
      />
    )
  }

  renderReportAssetTab() {
    return(
      <ReportAssetPage
        ref='report_asset'
        onShowTabs={this.onShowTabs.bind(this)}
        onRowSelect={this.onRowSelect.bind(this)}
        showTbReportAssetPage={this.state.showTbReportAssetPage}
      />
    )
  }

  render(){
    let {activeKey,is_tab} = this.state
    let titleTab0 = 'ข้อมูลสินทรัพย์/เครื่องจักร'
    let titleTab1 = 'ข้อมูลอุปกรณ์ติดรถ/เครื่องจักร'
    return (
      <div>
        {is_tab?
        <Tabs 
          activeKey={activeKey}
          id='all-asset-tabs'
          onSelect={this.onTabsSelect.bind(this)}
        >
          <Tab eventKey={'vehicle'} title={titleTab0}></Tab>
          <Tab eventKey={'asset'} title={titleTab1}></Tab>
        </Tabs>
        :
        <Breadcrumb>
          <Breadcrumb.Item active={false} onClick={this.onBreadcrumbClick.bind(this,activeKey)}>
            <FontAwesome name='table' /> {activeKey==='vehicle'?'ตารางรายงานยานพาหนะ':'ตารางรายงานสินทรัพย์'}
          </Breadcrumb.Item>
          <Breadcrumb.Item active={true} onClick={()=>{}}>
            {activeKey==='vehicle'?'ข้อมูลสินทรัพย์ (รถ/เครื่องจักร)':'ใบงานสินทรัพย์'} {this.getItemDetail()}
          </Breadcrumb.Item>    
        </Breadcrumb>
        }
        <Switch>
          <Route exact path="/vehicle" render={(props) => this.renderReportAssetVehicleTab()}/>                            
          <Route exact path="/asset" render={(props) => this.renderReportAssetTab()}/>                            
          <Route render={(props) => this.renderReportAssetVehicleTab()}/>                         
        </Switch>
      </div>
    )
  }
}

const _Connect = connect(
  (state) => ({messages: state.message.view.asset.ReportAllAssetPage}),null,null,{withRef:true}
)(ReportAllAssetPage);

export default withRouter(_Connect)





// WEBPACK FOOTER //
// ./src/view/asset/ReportAllAssetPage.js